import { render, staticRenderFns } from "./BuildListScreen.vue?vue&type=template&id=47669cbb"
import script from "./BuildListScreen.vue?vue&type=script&lang=js"
export * from "./BuildListScreen.vue?vue&type=script&lang=js"
import style0 from "./BuildListScreen.vue?vue&type=style&index=0&id=47669cbb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports